import { Path, useFormContext, FieldValues, Controller, Control, PathValue } from "react-hook-form";
import { useTranslation } from "react-i18next";
import NumberInput, { NumberInputProps } from "../../../../util/component/NumberInput";

type FormNumberInputProps<IFormValues extends FieldValues = FieldValues> = Omit<NumberInputProps, 'onChange'> & {
    name: Path<IFormValues>,
    control?: Control<IFormValues, any>,
    defaultValue?: PathValue<IFormValues, Path<IFormValues>>,
    shouldUnregister?: boolean,
    onChange?: NumberInputProps['onChange']
}

const FormNumberInput = <IFormValues extends FieldValues = FieldValues>({
    name,
    control,
    shouldUnregister,
    ...props
}: FormNumberInputProps<IFormValues>) => {

    const { t } = useTranslation('booking');

    const formContext = useFormContext<IFormValues>();

    return (
        <Controller
            name={name}
            control={control ?? formContext.control}
            shouldUnregister={shouldUnregister}
            render={({ field, fieldState, formState }) =>
                <NumberInput
                    {...props}
                    defaultValue={field.value}
                    onChange={(value: number) => {
                        field.onChange(value);
                        props.onChange?.(value)
                    }}
                    /* onBlur={(e) => {
                        field.onBlur();
                        props.onBlur?.(e);
                    }} */
                    error={Boolean(fieldState.error)}
                    helperText={fieldState.error?.message ? t(fieldState.error.message) : props.helperText}
                    disabled={props.disabled ?? formState.isSubmitting}
                />
            }
        />
    );
};

export default FormNumberInput;
